// extracted by mini-css-extract-plugin
module.exports = {"card":"Funcionalidades_card__2X5y0","list":"Funcionalidades_list__vN-W-","image":"Funcionalidades_image__fXnnr"};